/**
 * 「有没有未保存改动」的判定。
 *
 * `baseline` 是当前打开的版本落盘时的快照串；**空串 = 还没打开任何版本**
 * （首屏、门禁页、刚切换代理数据还没拉回来）。这时没有任何东西可丢，必须判成「无改动」。
 *
 * 之前直接拿 `snap !== baseline` 判：空串对上任何快照都不相等，于是门禁页也一直
 * 挂着 beforeunload 拦截——账号密码登录成功后的整页重进被浏览器弹「要离开网站吗」，
 * 点「离开」还常常停在「登录中…」要手动刷新（John 2026-09-30）。Discord 回跳同理。
 *
 * 放在 lib 里而不是 App.tsx：纯函数才能被单测钉住「空基线不算脏」这条。
 */
export function isDirty(baseline: string, snapJson: string): boolean {
  if (baseline === "") return false;
  return snapJson !== baseline;
}
